<template>
  <div class="information-search-container">
    <!-- 左边搜索结果 start -->
    <div class="information-LeftSearch fl">
      <!-- 搜索框 -->
      <div class="information-LeftSearch-input fl">
        <el-input
          v-model="searchWord"
          placeholder="请输入搜索关键词"
          @keyup.enter.native="searchBtn"
        ></el-input>
        <el-button @click="searchBtn" class="searchBtn">搜索</el-button>
      </div>
      <!-- 搜索结果 -->
      <strong>
        共有<span>{{ resultsList.total }}</span
        >门包含<span>"{{ this.searchWord }}"</span>的资料
      </strong>
      <!-- 分类 -->
      <div class="information-LeftSearch-classify fl">
        <div class="information-LeftSearch-ClassifyTop fl">
          <h3 class="fl">分类:</h3>
          <span class="fr" @click="allFn">全部</span>
        </div>
        <div class="LeftSearch-classify">按行业</div>
        <div class="detailBox">
          <ul class="tatol">
            <li
              v-for="(item, index) in classifyList"
              :class="{ totalActive: activeOne == index }"
              @click="showOne(index, item.code)"
              :key="index"
            >
              {{ item.cateName }}
            </li>
          </ul>
          <!-- 下面的内容statrt -->
          <ul class="information-LeftDetail-middleContent">
            <el-empty
              v-if="resultsList.records && !resultsList.records.length"
              description="暂无数据"
            ></el-empty>
            <li
              class="fl"
              v-for="(results, index) in resultsList.records"
              :key="index"
              @click="goInformationDetail(results)"
            >
              <img :src="results.cover" alt="" class="fl" />
              <div class="LeftDetail-middleContent1 fl">
                <h4 class="fl">{{ results.title }}</h4>
                <span style="color: #676c71; margin-right: 2px">分享工匠</span>
                <span v-if="results.nickName != null">{{
                  results.nickName
                }}</span>
                <span v-else>ing</span>
                <p>
                  行业分类:
                  <em style="color: #333">{{ results.industryType }}</em>
                </p>
              </div>
              <div class="LeftDetail-middleContent2 fl">
                <p class="fl" style="width: 120px; margin-right: 10px">
                  浏览次数:<span v-if="results.views > 10000"
                    >{{ results.views / 10000 }}w</span
                  >
                  <span v-else>{{ results.views }}</span>
                </p>
                <p class="fl" style="margin-right: 10px">
                  上传时间:<span>{{ timestampToTime(results.auditTime) }}</span>
                </p>
                <p class="fl" style="width: 65px; margin-left: 10px">
                  <span style="color: #ee9c3f" v-if="results.integral != 0"
                    >积分:{{ results.integral }}</span
                  >
                  <span style="color: #ee9c3f" v-else>免费</span>
                </p>
              </div>
            </li>
          </ul>
          <!-- 下面的内容 end -->
          <!-- 分页 start-->
          <div class="footer-pagination">
            <el-pagination
              v-if="this.total != 0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="queryInfo.pagenum"
              :page-size="queryInfo.pagesize"
              layout="prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
          <!-- 分页end -->
        </div>
      </div>
    </div>
    <!-- 左边搜索结果 end -->
    <!-- 右边 start -->
    <div class="information-RightSearch fr">
      <!-- 上传文档start -->
      <div class="information-Rightdetail-two">
        <div class="upload-document-information">
          <img src="../uploads/findinformation file.png" alt="" class="fl" />
          <p class="fl">
            已有<span>超过100000</span>会员上传并分享了文档，你的文档在哪里？
          </p>
          <el-button class="upload-document-points" @click="goDocument"
            >上传文档获取积分</el-button
          >
        </div>
      </div>
      <!-- 上传文档 end -->
      <!-- 相关资讯 start -->
      <div class="information-Rightdetail-four">
        <div class="hot-search fl">
          <p class="hot-search-word fl">相关资讯</p>
          <strong></strong>
        </div>
        <ul class="latest-upload fl">
          <li
            v-for="(news, index) in newsList.records"
            :key="index"
            @click="goNewsDeatils(news)"
          >
            <div class="point fl"></div>
            <p>{{ news.messageTitle }}</p>
          </li>
        </ul>
      </div>
      <!-- 相关资讯 end -->
      <!-- 相关课程 start -->
      <div class="information-Rightdetail-three">
        <div class="hot-courses-information fl">
          <h4>相关课程</h4>
          <span></span>
          <CourseTemplate />
        </div>
      </div>
      <!-- 相关课程 end -->
      <!-- 热门职业 start -->
      <div class="hot-occupation fl">
        <h4 style="margin-left: 0px">热门职业</h4>
        <span></span>
        <ul class="hot-occupation-message">
          <li
            v-for="(work, index) in workList.slice(0, 8)"
            @click="goJobDetail(work.id)"
            :key="work.id"
          >
            <p class="fl">
              {{ work.title }}
            </p>
            <p class="fl">
              <em>{{ work.minSalary }}k</em>
              <em>-</em>
              <em>{{ work.maxSalary }}k</em>
            </p>
          </li>
        </ul>
      </div>
      <!-- 热门职业 end -->
    </div>
    <!-- 右边 end -->
    <div style="clear: both"></div>
  </div>
</template>

<script>
import { searchDocument } from "@/api/data/index";
import { allHotRecruitment, topCates } from "@/api/common";
import { getPageByType } from "@/api/news/index";

export default {
  name: "InformationSearch",
  data() {
    return {
      queryInfo: {
        pagenum: 1,
        pagesize: 10,
      },
      queryInfoAll: {
        pagenum: 1,
        pagesize: 10,
      },
      workList: [], // 热门职位
      resultsList: [], // 结果
      classifyList: [], // 行业分类
      activeOne: null, //一级分类名称显示
      total: 0,
      searchWord: "",
      type: "",
      newsList: [], // 相关资讯
    };
  },
  mounted() {
    if (this.$route.params.searchWord != undefined) {
      this.searchWord = this.$route.params.searchWord;
    } else {
      this.searchWord = "";
    }
    this.$route.params.searchWord = "";

    // 顶级行业
    topCates().then((res) => {
      if (res.code == 200) {
        this.classifyList = res.data;
      }
    });
    // 行业分类切换搜索结果
    var param = this.searchWord;
    param = encodeURIComponent(param);
    const data = {
      current: this.queryInfoAll.pagenum,
      size: this.queryInfoAll.pagesize,
      title: param,
      industryType: this.type,
      type: this.type,
    };
    searchDocument(data).then((res) => {
      this.resultsList = res.data;
      this.total = res.data.total;
    });

    // 热门职位
    ceHotRecruitment().then((res) => {
      this.workList = res.data;
    });
    // 按行业类型查找分页
    getPageByType(data).then((res) => {
      if (res.code == 200) {
        this.newsList = res.data;
      }
    });
  },
  watch: {
    searchWord: {
      // 监视的处理函数
      handler(val) {
        this.getPageData(val);
      },
    },
  },
  methods: {
    allFn() {
      this.activeOne = null;
      this.type = "";
      this.queryInfo.pagenum = 1;
      this.getPageData();
    },
    showOne(index, code) {
      this.activeOne = index;
      this.type = code;
      this.queryInfo.pagenum = 1;
      this.getPageData();
    },
    getPageData() {
      var param = this.searchWord;
      param = encodeURIComponent(param);
      const data = {
        current: this.queryInfo.pagenum,
        size: this.queryInfo.pagesize,
        title: param,
        industryType: this.type,
      };
      searchDocument(data).then((res) => {
        this.resultsList = res.data;
        this.total = res.data.total;
      });
    },
    // 搜索按钮
    searchBtn() {
      this.queryInfo.pagenum = 1;
      this.getPageData();
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getPageData();
    },
    // 监听page页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getPageData();
    },
    goDocument() {
      this.$router.push({
        path: "/user/uploaddata",
      });
    },
    goJobDetail(id) {
      this.$router.push({
        path: "/jobdetails?id=" + id,
      });
    },
    goInformationDetail(results) {
      this.$router.push({
        path: "/informationdetail?id=" + results.id,
      });
    },
    goNewsDeatils(news) {
      this.$router.push({
        path: "/newsdetails?id=" + news.id,
      });
    },

    timestampToTime(time) {
      // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var date = new Date(time);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "年" + MM + "月" + d + "日";
    },
  },
};
</script>

<style scoped>
/* 版心 */
.information-search-container {
  width: 1200px;
  height: auto;
}
/* 左边搜索结果 start */
.information-LeftSearch {
  position: relative;
  width: 789px;
  height: 185px;
  background-color: #fff;
}
/* 搜索框 */
.information-LeftSearch-input {
  margin: 20px;
  width: 737px;
  height: 50px;
}
.information-LeftSearch-input >>> .el-input--small {
  width: 640px;
}
.information-LeftSearch-input >>> .el-input__inner {
  float: left;
  width: 640px;
  height: 50px;
  font-size: 14px;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #eb5139;
  border-right: 0;
}
.searchBtn {
  float: right;
  width: 97px;
  height: 50px;
  color: #fff;
  border: 0;
  border-radius: 0px;
  background: #eb5139;
}
/* 分类 */
.information-LeftSearch-Classify {
  position: relative;
}
/* 总共有几条的定位 */
.information-LeftSearch strong {
  position: absolute;
  top: 200px;
  left: 0px;
  font-weight: 400;
}
.information-LeftSearch strong span {
  font-weight: 600;
}
/* 分类的头部 */
.information-LeftSearch-ClassifyTop {
  padding-left: 20px;
  margin-top: 10px;
  width: 86px;
}
.information-LeftSearch-ClassifyTop h3 {
  font-size: 16px;
  color: #000;
}
.information-LeftSearch-ClassifyTop span {
  display: inline-block;
  width: 43px;
  height: 22px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  background-color: #fef6f5;
  color: #eb5139;
  cursor: pointer;
}
.LeftSearch-classify {
  position: absolute;
  top: 136px;
  left: 60px;
  width: 50px;
  height: 22px;
  font-size: 14px;
  text-align: center;
  background: #eb5139;
  border-radius: 10px 0px 10px 10px;
  color: #fff;
}
.detailBox {
  margin-top: 45px;
}
.detailBox strong {
  display: inline-block;
  margin-top: 50px;
  font-weight: 400;
}
.tatol {
  display: flex;
  margin-left: 110px;
  margin-bottom: 70px;
}
.tatol > li {
  width: 60px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.totalActive {
  font-size: 14px;
  color: #eb5139;
  border-radius: 4px;
}

/* 选项下面的内容 */
.information-LeftSearch-ClassifyContent p {
  font-size: 14px;
  color: #999999;
}
.information-LeftSearch-ClassifyContent p span {
  color: #333;
}

/* 内容区域的大盒子 */
/* 内容区域 */
.information-LeftDetail-middleContent {
  width: 789px;
  height: 950px;
  overflow: hidden;
  background-color: #fff;
}
/* 下边的每一行 */
.information-LeftDetail-middleContent li {
  box-sizing: border-box;
  margin-left: 0;
  position: relative;
  margin: 20px 0;
  padding: 0 20px;
  width: 789px;
  height: 55px;
  cursor: pointer;
}
.information-LeftDetail-middleContent li::after {
  content: "";
  position: absolute;
  top: 73px;
  left: 0;
  width: 789px;
  height: 0px;
  border: 1px solid #e5e5e5;
}
.information-LeftDetail-middleContent li:nth-child(10)::after {
  width: 0;
}
.information-LeftDetail-middleContent li img {
  width: 45px;
  height: 55px;
}
/* 图片右边的文字 */
.LeftDetail-middleContent1 {
  margin-left: 18px;
  width: 280px;
}
.LeftDetail-middleContent1 h4 {
  margin-right: 14px;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.LeftDetail-middleContent1 span {
  display: inline-block;
  margin-top: 4px;
  width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.LeftDetail-middleContent1 p {
  margin-top: 10px;
  font-size: 14px;
  color: #676c71;
}
/* 图片右边的浏览次数 */
.LeftDetail-middleContent2 {
  margin-top: 4px;
  width: 400px;
}
.LeftDetail-middleContent2 p {
  font-size: 12px;
  color: #cbcbcb;
}
.LeftDetail-middleContent2 p span {
  color: #676c71;
}
/* 分页 */
.footer-pagination {
  box-sizing: border-box;
  margin-left: 0;
  position: absolute;
  top: 1200px;
  left: 30px;
  width: 789px;
  height: 55px;
}
.footer-pagination >>> .el-pagination {
  width: 510px;
  height: 24px;
  color: #555656;
}
/* 经过每一个没有选中的数字的颜色 */
.footer-pagination >>> .el-pager li.number {
  color: #555656;
}
/* 左箭头 */
.footer-pagination >>> .el-pagination.is-background .btn-prev {
  background-color: transparent;
}
/* 右箭头 */
.footer-pagination >>> .el-pagination.is-background .btn-next {
  background-color: transparent;
}
/* 数字框 */
.footer-pagination >>> .el-input__inner {
  width: 45px;
  height: 24px;
  border-radius: 2px 2px 2px 2px;
}

/* 左边搜索结果 end */

/* 右边搜索结果 start */
.information-RightSearch {
  width: 391px;
  height: auto;
  background-color: #fff;
}
/* 热门文档 start*/
.information-Rightdetail-two {
  width: 391px;
  height: 251px;
  margin-top: 30px;
  border-bottom: 1px solid #f0f0f5;
}

/* 上传积分的信息部分start */
.upload-document-information {
  margin-bottom: 5px;
  margin-left: 20px;
  height: 251px;
}
/* 上传文档积分的图片 */
.upload-document-information img {
  width: 143px;
  height: 109px;
  padding: 20px 25px;
}
/* 上传文档积分的文字 */
.upload-document-information p {
  width: 196px;
  height: 40px;
  font-size: 14px;
  margin-top: 55px;
  color: #333;
  margin-left: -50px;
}
/* 上传文档积分的变色文字 */
.upload-document-information p span {
  color: #ff2222;
}
/* 上传文档积分的按钮 */
.upload-document-points {
  margin-right: 50px;
  margin-left: 120px;
  margin-top: 5px;
  width: 137px;
  height: 49px;
  color: #fff;
  border-radius: 8px;
  border: 0;
  background-color: #ff2222;
}
/* 热门文档 end */
/* 相关资讯 start */
.hot-search {
  position: relative;
  width: 120px;
  padding: 20px;
  height: 22px;
}
.hot-search-word {
  position: absolute;
  top: 32px;
  left: 20px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
/* 下面的横条 */
.hot-search strong {
  display: inline-block;
  margin-top: 27px;
  width: 65px;
  height: 9px;
  background: #eb5139;
}
.latest-upload {
  position: relative;
  width: 351px;
  height: auto;
  padding: 0 25px;
  border-bottom: 1px solid #f5f7fa;
}

/* 每一行 */
.latest-upload li {
  margin: 10px 4px;
  width: 315px;
  text-align: center;
  cursor: pointer;
}
/* 小圆点 */
.latest-upload li .point {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #676c71;
}
/* 文字 */
.latest-upload li p {
  width: 280px;
  height: 20px;
  line-height: 15px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #000000;
}
/* 相关资讯 end */

/* 相关课程 start */
.hot-courses-information {
  position: relative;
  width: 351px;
  padding: 20px;
  height: 685px;
  border-bottom: 1px solid #f0f0f5;
  overflow: hidden;
}
.hot-courses-information h4 {
  position: absolute;
  top: 25px;
  left: 21px;
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
/* 下面的橙色横线 */
.hot-courses-information span {
  display: inline-block;
  margin-top: 20px;
  margin-bottom: 12px;
  width: 65px;
  height: 8px;
  background: #eb5139;
}
/* 热门职业 start */
.hot-occupation {
  position: relative;
  padding: 20px;
  height: auto;
  overflow: hidden;
}
.hot-occupation h4 {
  position: absolute;
  top: 25px;
  left: 20px;
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
/* 下面的橙色线 */
.hot-occupation span {
  display: inline-block;
  margin-top: 20px;
  width: 65px;
  height: 8px;
  background: #eb5139;
}
/* 文字信息 */
.hot-occupation-message {
  display: flex;
  flex-direction: column;
}
.hot-occupation-message li {
  padding: 10px 0;
  cursor: pointer;
}
.hot-occupation-message li p {
  width: 200px;
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.hot-occupation-message li p:nth-child(1) {
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hot-occupation-message li p em {
  font-size: 14px;
  font-weight: 600;
  color: #ffb865;
}
/* 热门职业 end */

/* 右边搜索结果 end */
</style>